import { render, staticRenderFns } from "./MailDefault.vue?vue&type=template&id=acebcfc0&scoped=true"
import script from "./MailDefault.vue?vue&type=script&lang=js"
export * from "./MailDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acebcfc0",
  null
  
)

export default component.exports